<div class="header">
  <a href="https://www.csfapl.it/">
    <div class="logo"></div>
  </a>
</div>
